/**
 * @module support/shared/widgets / Component Text Area
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ViewChildren,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { AlertEventInterface } from '@support/shared/widgets/interfaces/toggle-alert.interface';
import { ObjectInterface } from '@support/api/common/api-response.interface';
import { SYMBOL_CONSTANTS } from '@support/shared/constants/device.constants';

@Component({
  selector: 'tmo-page-titles',
  templateUrl: './page-titles.component.html',
  styleUrls: ['../../../../../../style-sheets/components/page-titles.component.scss'],
})
export class PageTitlesComponent implements OnInit, OnDestroy, AfterViewInit {
  /**
   * Boolean variable to check if alert is expanded or contracted
   */
  public alertsExpanded: boolean;
  /**
   * Variable to store the symbol constants
   */
  public symbolConstant: ObjectInterface;

  /**
   * Boolean variable to check if alert is animation is toggled
   */
  public toggleAnim: boolean;

  /**
   * Input value for fractional pages
   */
  @Input() public isFractionalPage?: boolean;

  /**
   * Input value for the page title
   */
  @Input() public pageTitle?: string;

  /**
   * Input value for header input
   */
  @Input() public heading?: string;

  @Input() public accountId?: number;
  /**
   * Input value for account text
   */
  @Input() public accountText?: string;

  /**
   * Gray background for page title
   */
  @Input() public grayBackground?: boolean;

  /**
   * Verifies if the display page is an accountPage variant
   */
  @Input() public accountPage?: boolean;

  /**
   * Account nickname to display on the page
   */
  @Input() public nickName?: string;

  /**
   * Number of alerts to display
   */
  @Input() public numAlerts?: number;

  /**
   * Alert string suffix
   */
  @Input() public alertSuffix?: string;

  @Input() public notificationLoaded: boolean;

  @Input() public isP10MCustomer: boolean;

  @Input() public isDigitalCartTemplateEnabled: boolean;

  @Input() public digitalPageTitle: string;

  @Input() public digitalSubTitle: string;

  /**
   * Emits an event with the boolean value of the alerts if expanded or closed
   */
  @Output() public toggleAlertEmitter: EventEmitter<AlertEventInterface>;

  @ViewChildren('pageHeading') public pageHeading: ElementRef;

  constructor() {
    this.alertsExpanded = false;
    this.toggleAnim = false;
    this.toggleAlertEmitter = new EventEmitter();
    this.symbolConstant = SYMBOL_CONSTANTS;
  }

  public ngAfterViewInit(): void {
    if (this.pageHeading && this.pageHeading.nativeElement) {
      this.pageHeading.nativeElement.focus();
    }
  }

  /**
   * Inializes the data for page titles components.
   * @returns void
   */
  public ngOnInit(): void {
    this.alertsExpanded = this.numAlerts && this.numAlerts > 0;
  }
  /**
   * Toggles animation after delay
   * @returns boolean
   */
  public toggleAlerts(): void {
    this.toggleAnim = !this.toggleAnim;
    this.toggleAlertEmitter.emit({ toggleAlerts: this.alertsExpanded });
    if (this.alertsExpanded) {
      const rate = 350;
      setTimeout(() => {
        this.alertsExpanded = !this.alertsExpanded;
      }, rate);
    } else {
      this.alertsExpanded = !this.alertsExpanded;
    }
  }

  /**
   * Destroys all the subsciptions.
   * @returns void
   */
  public ngOnDestroy(): void {
    this.toggleAlertEmitter.unsubscribe();
  }
}
